module.exports = __webpack_public_path__ + "static/media/MONEDERO.19d157f4.svg";